// extracted by mini-css-extract-plugin
module.exports = {"root":"Labeled_root__3RIEE","label":"Labeled_label__1TQ2L","divider":"Labeled_divider__2cld-"};